import "@hotwired/turbo";
import Bridge from "../turbo/bridge.tsx";

// check if is access by app and do some configuration if so
const regex = new RegExp(/tixxt App/gm);
window.isApp = regex.test(window.navigator.userAgent);

// Global helper stuff
if (window.isApp) {
  window.bridge = Bridge;

  document.addEventListener("turbo:load", Bridge.configureLayout);

  document.addEventListener("turbo:render", () => {
    const pageTitle = document.querySelector(
      "#static-page-title h1",
    )?.textContent;
    if (pageTitle) {
      window.bridge.setPageTitle(pageTitle);
    }
  });
}
